module.exports = __webpack_public_path__ + "img/a9_10.94a4c76b.jpg";